import { http } from "@/lib/request";

export interface GoodsDetailComment {
  id: number;
  comment?: string;
  service_comment?: number;
  create_time?: string;
  user?: {
    nickname?: string;
    avatar?: string;
  };
  goods_comment_image?: Array<{
    uri?: string;
  }>;
}

export interface GoodsCoupon {
  id: number;
  money: number;
  condition?: string;
  tips?: string;
  use_end_time_text?: string;
  get_status?: number;
}

export interface GoodsDetailResult {
  id: number;
  name?: string;
  image?: string;
  price?: number;
  scribing_price?: number;
  content?: string;
  duration?: number;
  tags?: string;
  total_order_num?: number;
  is_collect?: number;
  goods_image?: string[];
  comment_lists?: GoodsDetailComment[];
  comment_count?: number;
  coupon_lists?: GoodsCoupon[];
}

export interface AppendGoodsItem {
  id: number;
  name?: string;
  image?: string;
  price?: number;
  duration?: number;
  goods_image?: string[] | string;
}

export interface AppendGoodsPageResult {
  records?: AppendGoodsItem[];
  lists?: AppendGoodsItem[];
  total?: number;
  count?: number;
  size?: number;
  current?: number;
}

export const goodsApi = {
  getGoodsDetail(id: number | string) {
    return http.get<GoodsDetailResult>("/goods/detail", {
      params: { id },
    });
  },

  getAppendGoodsList(params?: { pageNum?: number; pageSize?: number; categoryId?: number; keyword?: string }) {
    return http.get<AppendGoodsPageResult>("/goods/appendList", {
      params,
    });
  },
};
